import RssFeedIcon from '@kijiji/icons/src/icons/RssFeed'

import { LinkCustom } from '../link-custom/LinkCustom'
import { RSSFeedLinkContainer } from './styled'

export type RSSFeedLinkProps = {
  /** Url to be redirected to the rss feed */
  url: string
  title: string
}

export const RSSFeedLink = ({ url, title }: RSSFeedLinkProps) => (
  <RSSFeedLinkContainer data-testid="srp-rss-feed-button">
    <LinkCustom href={url} title={title} rel="nofollow" aria-label={title}>
      <RssFeedIcon aria-hidden data-testid="rss-feed-icon" />
    </LinkCustom>
  </RSSFeedLinkContainer>
)
